import React from 'react';
import { formIcons, IFormIconName } from './icons-map';

type Props = {
  name?: IFormIconName;
  size?: number;
  fill?: string;
};

export const FormIcon: React.FC<Props> = ({
  name,
  size = 24,
  fill = 'white',
 }) => {
  if (!name) {
    return null;
  }

  const Icon = formIcons[name];

  if (!Icon) {
    return null;
  }

  return <Icon width={`${size}px`} height={`${size}px`} fill={fill} />;
};
